import { questionById } from '../../data/brsr/questions'
import type { AnswerMap, BrsrQuestion } from '../../data/brsr/types'

export function optionLabel(question: BrsrQuestion, value: string): string {
  return question.options?.find((option) => option.value === value)?.label ?? value
}

export function responseLabel(questionId: string, responses: AnswerMap): string {
  const question = questionById(questionId)
  const value = responses[questionId]
  if (!question || value == null || value === '' || (Array.isArray(value) && value.length === 0)) {
    return 'Not answered'
  }
  if (Array.isArray(value)) return value.map((item) => optionLabel(question, item)).join(', ')
  if (question.kind === 'text') return value
  return optionLabel(question, value)
}

export function scalarAnswer(responses: AnswerMap, id: string): string {
  const value = responses[id]
  return typeof value === 'string' ? value : ''
}
